import { setTerms } from './helpers';

export const setBuildingClassTypeWarehouse = setTerms('building_class_type__warehouse');
